import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/modules/core/services';
import { ConfigService } from 'src/config';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [MatButtonModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class LoginComponent implements OnInit {
    private _authService = inject(AuthService);
    private _router = inject(Router);
    private _config = inject(ConfigService);

    public environmentName = '';


    constructor() {
        if (this._authService.isOnline()) {
            this._router.navigateByUrl('');
        }
    }

    ngOnInit(): void {
        this.environmentName = this._config.environmentName;
    }

    public login() {
        this._authService.login(true);
    }
}
